import { Injectable, signal } from '@angular/core';

import { UserData } from '../../reservation.model';

import { ReservationSummaryStoreService } from './reservation-summary-store.service';
import { DateService } from '../../../common/date.service';
import { MatDialog } from '@angular/material/dialog';
import { ReservationSummaryCancelDialogComponent } from '../reservation-summary-accomodation/reservation-summary-cancel-dialog/reservation-summary-cancel-dialog.component';
import { ReservationService } from '../../reservation.service';

@Injectable({
	providedIn: 'root',
})
export class ReservationSummaryCommonService {
	readonly offerIdToChange = signal<number>(null);

	private readonly weekday = ['PON', 'WT', 'ŚR', 'CZW', 'PT', 'SO', 'ND'];

	constructor(
		private readonly store: ReservationSummaryStoreService,
		private readonly dateService: DateService,
		public dialog: MatDialog,
		public service: ReservationService,
	) {}

	getUserName(user: UserData) {
		const firstName = user?.firstName ?? '';
		const lastName = user?.lastName ?? '';
		return `${firstName} ${lastName}`;
	}

	daysBetween(startDate: string, endDate: string): number {
		return Math.floor(this.dateService.daysBetween(startDate, endDate));
	}

	getDate(datetime: string) {
		return this.dateService.apiToDateTime(datetime).date;
	}

	getTime(datetime: string) {
		return this.dateService.apiToDateTime(datetime).time;
	}

	getWeekday(datetime: string) {
		const dateObj = new Date(datetime);
		const index = dateObj.getDay() === 0 ? 6 : dateObj.getDay() - 1;
		return this.weekday[index];
	}

	showCancelDialog(config: { reservationId: number; offerId: number; slotId: number }) {
		const dialogRef = this.dialog.open(ReservationSummaryCancelDialogComponent, {
			minWidth: '620px',
			data: config,
		});
	}
}
